import { useParams, Link } from 'react-router-dom';
import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import PageSEO from '@/components/base/PageSEO';
import VideoCard from '@/components/feature/VideoCard';
import { categories, videos } from '@/mocks/videos';
import { useState, useEffect } from 'react';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'mingxing-heiliao');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
      window.scrollTo({ top: 0 });
    }
  }, [slug]);

  const currentCategory = useMemo(
    () => categories.find((c) => c.slug === activeSlug),
    [activeSlug],
  );

  const filteredVideos = useMemo(
    () => videos.filter((v) => v.categorySlug === activeSlug),
    [activeSlug],
  );

  const categoryJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    'name': `${currentCategory?.name || '黑料视频'} - 黑料视频`,
    'description': `黑料视频${currentCategory?.name || ''}分类，收录最新最全${currentCategory?.name || '明星黑料'}视频内容。`,
    'url': `https://heiliaoshipin.com/category/${activeSlug}`,
    'isPartOf': {
      '@type': 'WebSite',
      'name': '黑料视频',
      'url': 'https://heiliaoshipin.com',
    },
    'breadcrumb': {
      '@type': 'BreadcrumbList',
      'itemListElement': [
        { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'https://heiliaoshipin.com/' },
        { '@type': 'ListItem', 'position': 2, 'name': currentCategory?.name || '分类', 'item': `https://heiliaoshipin.com/category/${activeSlug}` },
      ],
    },
  };

  return (
    <>
      <PageSEO
        title={`${currentCategory?.name || '黑料视频'} - 黑料视频 | 最新${currentCategory?.name || '明星黑料'}视频大全`}
        description={`黑料视频${currentCategory?.name || ''}分类，收录最新最全${currentCategory?.name || '明星黑料'}视频内容，涵盖艺人丑闻、翻车现场、争议事件等真实影像记录，持续更新热门黑料视频。`}
        canonicalUrl={`https://heiliaoshipin.com/category/${activeSlug}`}
        jsonLd={categoryJsonLd}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: currentCategory?.name || '分类' },
            ]}
          />

          <div className="mb-8">
            <h1 className="font-heading text-2xl md:text-3xl text-foreground-100 mb-3">
              {currentCategory?.name || '黑料视频'}
            </h1>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-3xl">
              黑料视频{currentCategory?.name || ''}分类，收录最新最全{currentCategory?.name || '明星黑料'}视频内容。涵盖艺人丑闻、翻车现场、争议事件等真实影像记录，持续更新热门黑料视频，带你看清娱乐圈背后真相。
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-8 pb-6 border-b border-background-300/60">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all duration-200 ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-400 border border-background-300/60 hover:text-foreground-200 hover:border-foreground-400'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {filteredVideos.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {filteredVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200/70">
                <i className="ri-video-line text-2xl text-foreground-600"></i>
              </div>
              <p className="text-foreground-500 text-sm">该分类暂无视频内容，敬请期待</p>
              <Link
                to="/"
                className="inline-flex items-center gap-1 mt-4 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                <i className="ri-arrow-left-line"></i> 返回首页
              </Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}